import { useWalletDetails } from "@sundae/wallet-react";
import { FC, PropsWithChildren, useEffect } from "react";
import { hotjar } from "react-hotjar";

import { HOTJAR_ID } from "../../constants/SundaeSwap.constants";
import { useProfileAppContext } from "../../stores/ProfileAppContext";

const HotjarProvider: FC<PropsWithChildren<Object>> = ({ children }) => {
  const {
    state: { hotjarEnabled },
  } = useProfileAppContext();

  const { details } = useWalletDetails();
  const mainAddress = details?.mainAddress;

  useEffect(() => {
    if (hotjarEnabled) {
      hotjar.initialize(HOTJAR_ID, 6);
    }
  }, [hotjarEnabled]);

  useEffect(() => {
    if (hotjar.initialized() && mainAddress) {
      hotjar.identify(mainAddress, {});
    }
  }, [mainAddress]);

  return <>{children}</>;
};

export default HotjarProvider;
